export const AVAILABLE = 'available'
export const CANNOT_BE_DELIVERED = 'cannotBeDelivered'
export const WITHOUT_STOCK = 'withoutStock'
